export default {
  errors: [],
  notifications: [],
  showLoading: false,
  suiteVersion: '',
};
